var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.848 4.848a3.043 3.043 0 1 1 4.304 4.304 3.043 3.043 0 0 1-4.304-4.304M7 5.295a1.704 1.704 0 1 0 0 3.41 1.704 1.704 0 0 0 0-3.41",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 1.34a5.66 5.66 0 0 0-4.003 9.663l3.358 3.357a.913.913 0 0 0 1.29 0l3.358-3.357A5.66 5.66 0 0 0 7 1.339m-3.889-.16a7 7 0 0 1 8.839 10.77l-3.358 3.357a2.253 2.253 0 0 1-3.183 0L2.05 11.95A7 7 0 0 1 3.111 1.18",
    clipRule: "evenodd"
  })));
};
export default SvgMapPin;